import { gettext } from '@eventbrite/i18n';
import { Tabs, TabsItem } from '@eventbrite/marmalade';
import React from 'react';
import styles from './AgendaTabs.module.scss';
import { Tab } from './types';

export const AgendaTabs = ({
    tabs,
    onTabClick,
}: {
    tabs: Tab[];
    onTabClick: (tab: Tab) => void;
}) => {
    const tabItemClassnames = [
        styles.agendaTabs__item,
        styles['agendaTabs__item--centered'],
    ].join(' ');

    if (tabs.length === 1) {
        return null;
    }

    return (
        <>
            <Tabs
                defaultValue={tabs[0].name}
                aria-label={gettext('Agenda tabs').toString()}
                onValueChange={(value) =>
                    onTabClick(
                        tabs.find((tab) => tab.name === value) || tabs[0],
                    )
                }
                className={styles.agendaTabs__list}
            >
                {tabs.map((tab) => (
                    <TabsItem
                        key={tab.name}
                        value={tab.name}
                        className={tabItemClassnames}
                    >
                        {tab.name}
                    </TabsItem>
                ))}
            </Tabs>
        </>
    );
};
